import { render, staticRenderFns } from "./WhatsNews.vue?vue&type=template&id=2f8d9132&scoped=true"
import script from "./WhatsNews.vue?vue&type=script&lang=js"
export * from "./WhatsNews.vue?vue&type=script&lang=js"
import style0 from "./WhatsNews.vue?vue&type=style&index=0&id=2f8d9132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8d9132",
  null
  
)

export default component.exports